<script>
export default {
    props: {
        record: {
            type: Object,
            required: true
        }
    },

    computed: {
        addressLine1() {

            if(this.record.project_address) {
                return this.record.project_address.address
            }

            return null;
        },
        tradeAllyName() {

            if(!this.record.user) {
                return null;
            }

            return this.record.user.first_name + ' ' + this.record.user.last_name;
        },
        tradeAllyCompany() {

            if(!this.record.user || !this.record.user.company) {
                return null;
            }

            return this.record.user.company.name;
        },
    }
}
</script>
<template>
    <div class="flex items-center text-center">
        <div class="companyname col-md-4">{{ record.customer_company_name }}&nbsp;</div>
        <span class="companyaddress col-md-4">{{ addressLine1 }}</span>
        <div class="tradeally-contact col-md-4">
            {{ tradeAllyName }}<br />
            {{ tradeAllyCompany }}
        </div>
    </div>
</template>
